import React, { useEffect, useState } from "react";
import Routes from "../Routes";

import CommonSidebar from "../Common/CommonSidebar/CommonSidebar";
import CommonHeader from "../Common/CommonHeader/CommonHeader";
import CommonBreadcrumb from "../Common/CommonBreadcrumb/CommonBreadcrumb";

const AdminLayout = ({
  themeMode,
  themeColor,
  borderStroke,
  boxLayout,
  monochrome,
  borderRadius,
  iconColor,
  gradientColor,
  hideSidebar,
  hideHeader,
}) => {
  const [sidebarHidden, setSidebarHidden] = useState(false);
  
  const toggleSidebar = () => {
    setSidebarHidden((prevState) => !prevState);
  };


  return (
    <section
      data-ha={`theme-${themeColor}`}
      data-bs-theme={themeMode}
      className={`${gradientColor} ${
        sidebarHidden && "sidebar-hide"
      } ${borderStroke} ${boxLayout} ${monochrome} ${borderRadius}`}
    >
      {/* <main className="container-fluid px-0"> */}
      <main
        className={`${
          boxLayout === "box-layout rightbar-hide"
            ? "container"
            : "container-fluid"
        } px-0`}
      >
        {!hideSidebar && !sidebarHidden && (
          <CommonSidebar iconColor={iconColor} />
        )}

        <div className="content">
          {/* Only show header and breadcrumb if not hidden */}
          {!hideHeader && <CommonHeader toggleSidebar={toggleSidebar} />}
          {!hideHeader && <CommonBreadcrumb />}

          <Routes />
        </div>
      </main>
    </section>
  );
};

export default AdminLayout;
